import { Component, Input, OnChanges } from '@angular/core'

import { environment } from '../../../../../environments/environment'
import { ImageSize } from '../../../../common/enums/image-size.enum'

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnChanges {
  @Input() path: string
  @Input() size: ImageSize = ImageSize.Thumbnail
  @Input() replacement = environment.isAltVersion
    ? '/assets/img/avatar-alt.svg'
    : '/assets/img/avatar.svg'
  @Input() className = ''
  @Input() style = ''
  @Input() title = ''
  @Input() alt = 'image'

  absolutePath: string
  storagePath: string = environment.storagePath

  ngOnChanges() {
    // setTimeout to prevent 404 error on calling image too soon for API.
    setTimeout(() => {
      let sizePath: string

      // Adds extensions to images based on requested size.
      switch (this.size) {
        case ImageSize.Thumbnail:
          sizePath = `${this.path}-thumbnail.jpg`
          break
      }
      this.absolutePath = this.path
        ? `${this.storagePath}/${sizePath}`
        : this.replacement
    }, 150)
  }
}
